import { render, staticRenderFns } from "./receipt-detail-table.vue?vue&type=template&id=e45df472&scoped=true&"
import script from "./receipt-detail-table.vue?vue&type=script&lang=js&"
export * from "./receipt-detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45df472",
  null
  
)

export default component.exports